var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLigneBusRatp91(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120px",
    height: "77px",
    viewBox: "0 0 120 77",
    style: {
      enableBackground: "new 0 0 120 77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC9600"
    },
    width: 120,
    height: 77
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.603,69.986c-3.386,0-6.434-0.423-8.974-1.016l1.862-10.159c1.608,0.678,4.741,1.439,8.212,1.439 c8.381,0,14.476-6.688,15.322-18.709c-2.031,1.777-5.926,4.063-12.359,4.063c-9.905,0-17.862-6.519-17.862-17.693 c0-11.936,7.958-20.74,20.486-20.74c16.339,0,22.181,11.344,22.181,27.175C62.471,55.087,52.734,69.986,33.603,69.986z  M40.798,16.568c-5.926,0-8.974,4.826-8.974,9.99c0,5.587,3.725,9.651,9.651,9.651c3.81,0,6.857-1.439,8.042-3.302 c0.677-1.016,0.677-3.387,0.677-5.164C50.195,22.071,46.894,16.568,40.798,16.568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.84,68.378V21.394c-3.64,2.878-9.396,5.671-13.375,7.45l-4.063-9.143c6.265-2.624,13.799-6.603,19.725-11.09h10.413 v59.767H82.84z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLigneBusRatp91);
export default __webpack_public_path__ + "static/media/Logo_Ligne_Bus_RATP_91.0772d6d29063c4f6952ed5099d2a979b.svg";
export { ForwardRef as ReactComponent };